import { FormFieldInputType, FormFieldType, FormOptionType, GenerateFormFieldModel, SelectBoxModel } from "src/app/model";

export interface Configuration {
  attribute: string;
  description: string;
  type: string;
  values: string;
  _id: string;
}

// Configuration: genericFormData
export interface ConfigGenericFormDataModel {
  people?: GenerateFormFieldModel[];
  asset?: GenerateFormFieldModel[];
  vehicle?: GenerateFormFieldModel[];
}

// Configuration: entityDeviceOnboardFormConfig
export interface ConfigEntityOnboardFormModel {
  formSectionList: EntityOnboardSectionModel[];
  formResponse: EntityOnboardMessageModel;
}

export interface EntityOnboardSectionModel {
  sectionName?: string;
  sectionKey?: string;
  visible: boolean;
  fields: EntityOnboardFieldModel[];
}

export interface EntityOnboardFieldModel {
  key: string;
  visible: boolean;
  path?: string[];
  label?: string;
  fieldType?: FormFieldType;
  disabled?: boolean;
  mandatory?: boolean;
  inputType?: FormFieldInputType;
  validation?: string;
  options?: SelectBoxModel[];
  toggleOptions?: ToggleOptions[];
  optionType?: FormOptionType,
  defaultValue?: any;
  fetchValuekey?: string;
  apiConfig?: EntityOnboardApiConfigModel;
  children?: EntityOnboardFieldModel[];
}

export interface ToggleOptions {
    id: string,
    label: string,
    value: boolean,
    disabled?: boolean
}
export interface EntityOnboardApiConfigModel {
  endpoint: string;
  method: string;
  payload: string[],
  responseMap: {
    key: string;
    value: string;
  }
}

export interface EntityOnboardMessageModel {
  successMessage: string;
  errorMessage: string;
}